export function downloadErrorLog(
  summary: string,
  errors: string[],
  modelInstanceId: number,
  fileName: string
): void {
  const lines = [
    "Upload Validation Report",
    "=".repeat(44),
    `File           : ${fileName}`,
    `Date           : ${new Date().toLocaleString()}`,
    `Model Instance : ${modelInstanceId}`,
    "",
    `Summary: ${summary}`,
    "",
    `Validation Errors (${errors.length} shown):`,
    ...errors.map((e, i) => `  ${i + 1}. ${e}`),
  ];
  const blob = new Blob([lines.join("\n")], { type: "text/plain" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `upload_errors_${modelInstanceId}.txt`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
